export function setItem(
  key: string = '',
  data: any = null,
  di: StorageServiceDependencies = {}
): void {
  const {wndw = window, json = JSON} = di;
  const storage: Storage = wndw.localStorage;
  const converted = json.stringify(data);
  storage.setItem(key, converted);
}
